import * as THREE from 'three'
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js'
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js'
import { OutputPass } from 'three/addons/postprocessing/OutputPass.js'
import { viewport, onResize } from './viewport.js'
import { params } from '../config/persistence.js'

export const createRenderer = (canvas, scene, camera) => {
    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true })
    renderer.setSize(viewport.width, viewport.height)
    renderer.setPixelRatio(viewport.pixelRatio)
    renderer.setClearColor(params.backgroundColor)
    renderer.toneMapping = params.toneMapping
    renderer.toneMappingExposure = params.exposure
    renderer.outputColorSpace = THREE.SRGBColorSpace

    const composer = new EffectComposer(renderer)
    composer.addPass(new RenderPass(scene, camera))

    const bloomPass = new UnrealBloomPass(
        new THREE.Vector2(viewport.width, viewport.height),
        params.bloomStrength,
        params.bloomRadius,
        params.bloomThreshold,
    )
    composer.addPass(bloomPass)
    composer.addPass(new OutputPass())

    onResize((vp) => {
        renderer.setSize(vp.width, vp.height)
        renderer.setPixelRatio(vp.pixelRatio)
        composer.setSize(vp.width, vp.height)
        composer.setPixelRatio(vp.pixelRatio)
    })

    return { renderer, composer, bloomPass }
}
